import { render } from "./RegisterHirings.vue?vue&type=template&id=c6ff0438"
import script from "./RegisterHirings.vue?vue&type=script&lang=js"
export * from "./RegisterHirings.vue?vue&type=script&lang=js"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__